<template>
    <section class="tex2jax_ignore mathjax_ignore section" id="welcome-to-shared-atomic-s-documentation">
                <h1>{{t('__title')}}</h1>
                <p>{{t('__paragraph1')}}</p>
                <p>{{t('__paragraph2')}}</p>
                <p><ul>
                <li class='level1'><dot class='dot'/><router-link :to="{ name:'int_api'}">&nbsp;&nbsp;{{t('__link_atomic_int')}}</router-link></li>
                <li class='level1'><dot class='dot'/><router-link :to="{ name:'uint_api'}">&nbsp;&nbsp;{{t('__link_atomic_uint')}}</router-link></li>
                <li class='level1'><dot class='dot'/><router-link :to="{ name:'boolfloat_api'}">&nbsp;&nbsp;{{t('__link_atomic_bool')}}</router-link></li>
                <li class='level1'><dot class='dot'/><router-link :to="{ name:'boolfloat_api'}">&nbsp;&nbsp;{{t('__link_atomic_float')}}</router-link></li>
                <li class='level1'><dot class='dot'/><router-link :to="{ name:'bytearray_api'}">&nbsp;&nbsp;{{t('__link_atomic_bytearray')}}</router-link></li>
                <li class='level1'><dot class='dot'/><router-link :to="{ name:'atomic_shared_memory'}">&nbsp;&nbsp;{{t('__link_atomic_shared_memory')}}</router-link></li>
                <li class='level1'><dot class='dot'/><router-link :to="{ name:'shared_dict'}">&nbsp;&nbsp;{{t('__link_shared_dict')}}</router-link></li>
                </ul></p>
                <p v-html="t('__paragraph3')"/>
                <p v-if="!($is_wechat && width <= 768 && locale=='en')" class="purchase_process_title">{{t('__paragraph20')}}</p>
                <p v-if="!($is_wechat && width <= 768 && locale=='en')" class='purchase_process'>
                    <svg class='purchase_process_svg' preserveAspectRatio="none" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xl="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="3.595193 19.658628 2419.747 274.79633" width="2419.747" height="274.79633">
                      <defs/>
                      <g id="版面___" stroke-dasharray="none" fill-opacity="1" stroke="none" fill="none" stroke-opacity="1">
                        <title>购买流程</title>
                        <g id="版面____图层_1">
                          <title>图层 1</title>
                          <g id="Line_18">
                            <path d="M 265.3268 20.16641 C 10.326796 19.66641 25.86207 133.33333 25.86207 133.33333" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Line_19">
                            <path d="M 265.3268 20.16641 C 518.8268 19.16641 505.57373 114.86006 505.57373 114.86006" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Graphic_20">
                            <path d="M 419.68816 64.62985 C 501.79625 95.26336 501.79625 144.93004 419.68816 175.56354 C 337.5805 206.1972 204.45775 206.1972 122.35008 175.56354 C 40.24199 144.93004 40.24199 95.26336 122.35008 64.62985 C 204.45775 33.996193 337.5805 33.996193 419.68816 64.62985" fill="#e9967c"/>
                          </g>
                          <g id="Line_23">
                            <path d="M 505.57373 114.86006 C 505.8582 253.33435 505.6988 216.9918 505.6988 216.9918" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Line_26">
                            <path d="M 749.2616 293.95495 C 494.26156 293.45495 505.6988 221.7537 505.6988 221.7537" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Line_25">
                            <path d="M 749.2616 293.95495 C 1002.7616 292.95495 978.2024 221.1437 978.2024 221.1437" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Graphic_27">
                            <path d="M 894.0342 147.186 C 976.1423 175.69492 976.1423 221.917 894.0342 250.42593 C 811.9266 278.935 678.8038 278.935 596.69616 250.42593 C 514.58807 221.917 514.58807 175.69492 596.69616 147.186 C 678.8038 118.67691 811.9266 118.67691 894.0342 147.186" fill="#c0aac3"/>
                          </g>
                          <g id="Line_35">
                            <path d="M 1212.2007 21.753712 C 957.2007 21.253712 978.8494 116.99181 978.8494 116.99181" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Line_34">
                            <path d="M 1212.2007 21.753712 C 1465.7007 20.753712 1452.3258 113.8172 1452.3258 113.8172" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Graphic_33">
                            <path d="M 1363.3007 72.98022 C 1445.4088 105.13092 1445.4088 157.25746 1363.3007 189.40816 C 1281.193 221.55902 1148.0703 221.55902 1065.9627 189.40816 C 983.8546 157.25746 983.8546 105.13092 1065.9627 72.98022 C 1148.0703 40.829357 1281.193 40.829357 1363.3007 72.98022" fill="#92a1ad"/>
                          </g>
                          <g id="Line_32">
                            <path d="M 978.8494 116.99181 C 979.1339 233.46713 979.3963 223.39682 978.8494 223.39682" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Line_31">
                            <path d="M 1452.3258 113.8172 C 1452.6103 252.2915 1452.4509 209.0553 1452.4509 209.0553" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Line_30">
                            <path d="M 1696.0136 286.1849 C 1441.0136 285.6849 1452.4509 210.6426 1452.4509 210.6426" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Line_29">
                            <path d="M 1696.0136 286.1849 C 1949.5136 285.1849 1924.9544 213.37365 1924.9544 213.37365" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Graphic_28">
                            <path d="M 1845.149 145.04198 C 1927.2571 170.69224 1927.2571 212.2795 1845.149 237.92976 C 1763.0414 263.58016 1629.9186 263.58016 1547.811 237.92976 C 1465.7029 212.2795 1465.7029 170.69224 1547.811 145.04198 C 1629.9186 119.39159 1763.0414 119.39159 1845.149 145.04198" fill="#ff7171"/>
                          </g>
                          <g id="Line_40">
                            <path d="M 2157.041 23.341014 C 1902.041 22.841014 1925.6014 116.66667 1925.6014 116.66667" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Line_39">
                            <path d="M 2157.041 23.341014 C 2410.541 22.341014 2402.2989 125.80422 2402.2989 125.80422" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Graphic_38">
                            <path d="M 2312.0628 72.98022 C 2394.171 105.13092 2394.171 157.25746 2312.0628 189.40816 C 2229.9552 221.55902 2096.8324 221.55902 2014.7248 189.40816 C 1932.6167 157.25746 1932.6167 105.13092 2014.7248 72.98022 C 2096.8324 40.829357 2229.9552 40.829357 2312.0628 72.98022" fill="#71d2f7"/>
                          </g>
                          <g id="Line_37">
                            <path d="M 1925.6014 116.66667 C 1925.886 233.14199 1925.5014 213.37365 1924.9544 213.37365" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Graphic_67">
                            <ellipse cx="25.095193" cy="164.97022" rx="21.5000343548908" ry="20.5000327569889" fill="#e9967c"/>
                          </g>
                          <g id="Line_66">
                            <line x1="17.753671" y1="162.07666" x2="25.162322" y2="157.15567" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_65">
                            <line x1="32.876384" y1="162.07666" x2="25.16928" y2="157.162" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_64">
                            <line x1="17.760629" y1="162.083" x2="25.16928" y2="157.162" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_63">
                            <line x1="32.88334" y1="162.083" x2="25.176237" y2="157.16834" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_62">
                            <line x1="17.760629" y1="169.842" x2="25.16928" y2="164.92101" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_61">
                            <line x1="32.88334" y1="169.842" x2="25.176237" y2="164.92735" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Graphic_75">
                            <ellipse cx="979.7751" cy="164.97022" rx="21.5000343548908" ry="20.5000327569889" fill="#c0aac3"/>
                          </g>
                          <g id="Line_74">
                            <line x1="972.4336" y1="162.07666" x2="979.8423" y2="157.15567" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_73">
                            <line x1="987.5563" y1="162.07666" x2="979.8492" y2="157.162" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_72">
                            <line x1="972.4406" y1="162.083" x2="979.8492" y2="157.162" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_71">
                            <line x1="987.5633" y1="162.083" x2="979.8562" y2="157.16834" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_70">
                            <line x1="972.4406" y1="169.842" x2="979.8492" y2="164.92101" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_69">
                            <line x1="987.5633" y1="169.842" x2="979.8562" y2="164.92735" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Graphic_82">
                            <ellipse cx="1924.9455" cy="161.08755" rx="21.5000343548909" ry="20.5000327569888" fill="#ff7171"/>
                          </g>
                          <g id="Line_81">
                            <line x1="1917.604" y1="158.194" x2="1925.0127" y2="153.273" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_80">
                            <line x1="1932.7267" y1="158.194" x2="1925.0196" y2="153.27933" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_79">
                            <line x1="1917.611" y1="158.20033" x2="1925.0196" y2="153.27933" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_78">
                            <line x1="1932.7337" y1="158.20033" x2="1925.0266" y2="153.28567" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_77">
                            <line x1="1917.611" y1="165.95934" x2="1925.0196" y2="161.03834" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_76">
                            <line x1="1932.7337" y1="165.95934" x2="1925.0266" y2="161.04468" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_85">
                            <line x1="2402.2989" y1="125.80422" x2="2402.3296" y2="150.80366" stroke="#7f8080" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Line_86">
                            <line x1="26.310248" y1="122.62493" x2="26.23094" y2="144.47022" stroke="#7f8080" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                          </g>
                          <g id="Graphic_93">
                            <ellipse cx="503.5401" cy="164.97022" rx="21.5000343548909" ry="20.5000327569889" fill="#e9967c"/>
                          </g>
                          <g id="Line_92">
                            <line x1="512.0401" y1="166.5745" x2="503.71557" y2="172.12556" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_91">
                            <line x1="495.0479" y1="166.5745" x2="503.70775" y2="172.11842" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_90">
                            <line x1="512.03226" y1="166.56734" x2="503.70775" y2="172.11842" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_89">
                            <line x1="495.0401" y1="166.56734" x2="503.69993" y2="172.11127" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_88">
                            <line x1="512.03226" y1="157.81488" x2="503.70775" y2="163.36596" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_87">
                            <line x1="495.0401" y1="157.81488" x2="503.69993" y2="163.3588" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Graphic_100">
                            <ellipse cx="2401.842" cy="159.61617" rx="21.5000343548908" ry="20.5000327569889" fill="#71d2f7"/>
                          </g>
                          <g id="Graphic_114">
                            <ellipse cx="1452.3603" cy="163.49884" rx="21.5000343548908" ry="20.5000327569889" fill="#92a1ad"/>
                          </g>
                          <g id="Line_113">
                            <line x1="1460.8603" y1="165.1031" x2="1452.5358" y2="170.65418" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_112">
                            <line x1="1443.8682" y1="165.1031" x2="1452.528" y2="170.64703" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_111">
                            <line x1="1460.8525" y1="165.09596" x2="1452.528" y2="170.64703" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_110">
                            <line x1="1443.8603" y1="165.09596" x2="1452.5202" y2="170.63988" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_109">
                            <line x1="1460.8525" y1="156.3435" x2="1452.528" y2="161.89457" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_108">
                            <line x1="1443.8603" y1="156.3435" x2="1452.5202" y2="161.88742" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                          </g>
                          <g id="Line_115">
                            <line x1="270.1613" y1="232.25806" x2="270.41918" y2="198.53847" stroke="#e9967c" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4.0,4.0" stroke-width="1"/>
                          </g>
                          <g id="Line_116">
                            <line x1="744.6645" y1="125.80459" x2="744.3548" y2="93.54839" stroke="#c0aac3" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4.0,4.0" stroke-width="1"/>
                          </g>
                          <g id="Line_117">
                            <line x1="1215.3226" y1="241.93548" x2="1215.1453" y2="213.52106" stroke="#92a1ad" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4.0,4.0" stroke-width="1"/>
                          </g>
                          <g id="Line_118">
                            <line x1="1696.151" y1="125.80427" x2="1696.0136" y2="98.3871" stroke="#ff7171" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4.0,4.0" stroke-width="1"/>
                          </g>
                          <g id="Line_119">
                            <line x1="2163.7097" y1="243.8502" x2="2163.6246" y2="213.52125" stroke="#71d2f7" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4.0,4.0" stroke-width="1"/>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <div class='buy_enterprise_version'>{{t('__buy_enterprise_version')}}</div>
                    <div class='activation'>{{t('__acitvation')}}</div>
                    <div class='subscription'>{{t('__subscription')}}</div>
                    <div class='use_pip'>{{t('__use_pip')}}</div>
                    <div class='access_github'>{{t('__access_github')}}</div>
                    <div class='payment'>{{t('__payment')}}</div>
                    <div class='through_net'>{{t('__through_net')}}</div>
                    <div class='throw_maillist'>{{t('__throw_maillist')}}</div>
                    <div class='install_through_pip'>{{t('__install_through_pip')}}</div>
                    <div class='post_sales_support'>{{t('__post_sales_support')}}</div>
                </p>
                <p class="installation_process" v-html="t('__paragraph4')"/>
                <p v-html="t('__paragraph5')"/>
                <p v-html="t('__paragraph6')"/>
                <p><ul>
                <li class='level1'>
                    <dot class='dot'/>
                    CPython 3.7 - 3.14
                </li>
                </ul></p>
    
                <p v-html="t('__paragraph7')"/>

                <li class='level1'><dot class='dot'/>  {{t('__paragraph8')}}</li>
                <li class='level2'>{{t('__paragraph15')}}</li>
                <li class='level1'><dot class='dot'/>  {{t('__paragraph16')}}</li>
                <li class='level2'>{{t('__paragraph17')}}</li>
                <li class='level1'><dot class='dot'/>  {{t('__paragraph18')}}</li>
                <li class='level2'>{{t('__paragraph19')}}</li>

                <p v-html="t('__paragraph9')"/>
                <p v-html="t('__paragraph10')"/>
                <p v-html="t('__paragraph11')"/>
                <p v-html="t('__paragraph12')"/>
                <p v-html="t('__paragraph13')"/>
                <p v-html="t('__paragraph14')"/>
                <div>
                    <p><img alt="Python Logo" src="https://www.python.org/static/community_logos/python-logo.png" /></p>
                </div>
    </section>
</template>



<script>
import { useI18n } from "vue-i18n"
import dot from "../utils/dot.vue"
import { ref } from 'vue'

export default {
    setup() {
        let width = ref()
        let {t, locale} = useI18n({
                messages:
                {
                    'en': {
                         "__title": "Python lock-free shared data types"
                        ,"__paragraph1": "The module can be used for lock-free operations under multiple processs, multiple threads and multiple coroutines conditions."
                        ,"__paragraph2": "Included datatypes:"
                        ,"__paragraph3": "V4.2 is out! The newly designed master-free API and <a class=\"reference internal\" href=\"shared_dict\"><span class=\"doc std std-doc\"></span>concurrent sharable dict</span></a> is ready to boom your application performance and volatility on all major x64, arm64, and loongarch64 platforms.</a>"                        ,"__paragraph4": "For installation guide, please refer to <a class=\"reference external\" href=\"https://pypi.org/project/shared-atomic-enterprise/\">Shared Atomic Enterprise</a>. For loongarch64 platform, please download the binary distributions at <a class=\"reference external\" href=\"https://gitee.com/irvinren/shared_atomic_enterprise/releases/\">Shared Atomic Enterprise for Loongarch64</a>, then install the product by pip install shared_atomic_enterprise-5!xx-cp3x-none-linux_loongarch64.whl. To activate the enterprise version, please refer to <a class=\"reference internal\" href=\"atomic_tools.html\">Atomic tools</a>.For new requirements and bugs, please go to <a class=\"reference external\" href=\"https://sharedatomic.top:4343/\">Gitlab</a>."
                        ,"__paragraph4": "For installation guide, please refer to <a class=\"reference external\" href=\"https://pypi.org/project/shared-atomic-enterprise/\">Shared Atomic Enterprise</a>. For loongarch64 platform, please download the binary distributions at <a class=\"reference external\" href=\"https://gitee.com/irvinren/shared_atomic_enterprise/releases/\">Shared Atomic Enterprise for Loongarch64</a>, then install the product by pip install shared_atomic_enterprise-5!xx-cp3x-none-linux_loongarch64.whl. To activate the enterprise version, please refer to <a class=\"reference internal\" href=\"atomic_tools.html\">Atomic tools</a>.For new requirements and bugs, please go to <a class=\"reference external\" href=\"https://sharedatomic.top:4343/\">Gitlab</a>."
                        ,"__paragraph5": "You could also <a class=\"reference external\" href=\"mailto:shared_atomic_enterprise_subscriber%40sharedatomic.top\">subscribe or unsubscribe</a> our mailing list to get posted."
                        ,"__paragraph6": "Shared Atomic Enterprise Requirement:"
                        ,"__support": "Support "
                        ,"__paragraph7": "Supported platforms,"
                        ,"__paragraph8": "x86_64 platforms"
        				        ,"__paragraph15": "macOS Ventura and above, Microsoft Windows 10, 11, Windows Server 2019, 2022, Centos/RHEL 8, 9, 10, Suse Linux Enterprise Server 15, 16, Ubuntu Linux 18, 20, 22, 24, Debian 10, 11, 12, 13, KylinOS V10, V11, UnionTechOS 20, OpenEulerOS 20, 22, 24, BaiduLinux 3, Alibaba Cloud Linux 3, 4, TencentOS 3, 4"
        				        ,"__paragraph16":  "aarch64 platforms"
        				        ,"__paragraph17":  "Centos/RHEL 8, Ubuntu Linux 18(glibc updated to 2.28), 20, 22, 24, Debian 10, 11, 12, 13, KylinOS V10, UnionTechOS 20, OpenEulerOS 20, 22, Huawei Cloud EulerOS 2, Alibaba Cloud Linux 3, 4"
        				        ,"__paragraph18":  "loongarch64 platforms:"
        				        ,"__paragraph19":  "Loongix 20"
                        ,"__paragraph20":  "Purchase and utilisation process:"
                        ,"__paragraph9": "The package requires libgomp installed on Linux platform."
                        ,"__paragraph10": "urwid for activation. The embedded urwid_win_patch.py is under <a class=\"reference external\" href=\"https://www.gnu.org/licenses/old-licenses/lgpl-2.1.html\">GNU LESSER GENERAL PUBLIC LICENSE V2</a>"
                        ,"__paragraph11": "Microsoft Visual C++ 2019 Redistributable(X64) on Windows. If you still couldn't import the atomic_shared_memory after you installed the redistributable, please visit the <a class=\"reference external\" href=\"https://gitee.com/irvinren/shared_atomic_enterprise/blob/master/vcomp140.dll\">MS C/C++ OpenMP Runtime 14.29</a> on our git repo, download the missing DLL file and copy it into your %windir%\\system32 directory."
                        ,"__paragraph12": "windows-curses>=2.3.1 on windows."
                        ,"__paragraph13": "For example usage of the module, please visit this <a class=\"reference internal\" href=\"atomic_api_example\"><span class=\"doc std std-doc\">lock-free API example</span></a>."
                        ,"__paragraph14": "The article regarding the v2 of this product, titled \"Python shared atomic data types\" has recently been published by  <a class=\"reference external\" href=\"https://onlinelibrary.wiley.com/journal/1097024x\">Software: Practice and Experience</a>, doi: <a class=\"reference external\" href=\"https://onlinelibrary.wiley.com/doi/full/10.1002/spe.3259\">10.1002/spe.3259</a>. The v3 and v4 of this product achieved better performance and functionality."
                        ,"__link_atomic_int": "atomic_int"
                        ,"__link_atomic_uint": "atomic_uint"
                        ,"__link_atomic_bool": "atomic_bool"
                        ,"__link_atomic_float": "atomic_float"
                        ,"__link_atomic_bytearray": "atomic_bytearray"
                        ,"__link_atomic_shared_memory": "atomic_shared_memory"
                        ,"__link_shared_dict": "shared_dict"
                        ,'__buy_enterprise_version':"Buy enterprise version"
                        ,'__acitvation':"Activation"
                        ,'__subscription':"News subscription"
                        ,'__use_pip':"Use pip"
                        ,'__access_github':"Access Gitlab"
                        ,'__payment':"Use Wechat or Paypal"
                        ,'__through_net':"Through Internet or proxy server"
                        ,'__throw_maillist':"Through maillist"
                        ,'__install_through_pip':"Install pypi package"
                        ,'__post_sales_support':"Post sale support"
                    },
                    'zh_CN': {
                         "__title": "Python无需用锁的共享类型"
                        ,"__paragraph1": "此模块可以用来完成多线程，多进程或者多协程环境下的对共享数据的并发访问，无需用锁即可满足数据一致性。"
                        ,"__paragraph2": "包括数据类型："
                        ,"__paragraph3": "V4.2版已经上市! 新设计的无需主节点模式的API和<a class=\"reference internal\" href=\"shared_dict\"><span class=\"doc std std-doc\"></span>可并发访问的共享字典</span></a>可以用于更加灵活多变的基于x64, arm64和龙芯loongarch64的主流平台的高性能应用程序。</a>"
                        ,"__paragraph4": "安装此软件，请参考<a class=\"reference external\" href=\"https://pypi.org/project/shared-atomic-enterprise/\">Pypi包Shared Atomic Enterprise</a>。龙芯Loongarch64平台上本产品的安装，请到<a class=\"reference external\" href=\"https://gitee.com/irvinren/shared_atomic_enterprise/releases/\">Shared Atomic Enterprise for Loongarch64</a>下载二进制包，然后用pip install shared_atomic_enterprise-5!xx-cp3x-none-linux_loongarch64.whl进行安装。 激活企业版，请参见<a class=\"reference internal\" href=\"atomic_tools\">激活/修改代理服务器</a>。如果对此软件有更多需求和更多关于缺陷的提交, 请访问我们的<a class=\"reference external\" href=\"https://sharedatomic.top:4343/\">Gitlab</a>。"
                        ,"__paragraph5": "您也可以<a class=\"reference external\" href=\"mailto:shared_atomic_enterprise_subscriber%40sharedatomic.top\">续订或取消续订</a>我们的邮件列表以获取最新的产品信息。"
                        ,"__paragraph6": "企业版共享原子性安装依赖："
                        ,"__support": "支持"
                        ,"__paragraph7": "支持的平台："
                        ,"__paragraph8": "x86_64平台"
                        ,"__paragraph15": "全部功能需要macOS Ventura 及以上, Microsoft Windows 10, 11, Windows Server 2019, 2022, Centos/RHEL 8, 9, 10, Suse Linux Enterprise Server 15, 16, Ubuntu Linux 18, 20, 22, 24, Debian 10, 11, 12, 13, 麒麟V10, V11, 统信20, OpenEulerOS 20, 22, 24, 百度Linux 3，腾讯OS 3, 4，阿里巴巴云Linux 3, 4"
                        ,"__paragraph16":  "aarch64平台"
                        ,"__paragraph17":  "Centos/RHEL 8, Ubuntu Linux 18(glibc必须升级到2.28), 20, 22, 24, Debian 10, 11, 12, 13, 麒麟V10, 统信20, OpenEulerOS 20, 22, 华为云EulerOS 2, 阿里巴巴云Linux 3, 4"
                        ,"__paragraph18":  "Loongarch64平台"
                        ,"__paragraph19":  "Loongix 20"
                        ,"__paragraph20":  "产品购买与使用流程:"
                        ,"__paragraph9": "企业版在linux平台上需要libgomp。"
                        ,"__paragraph10": "企业版激活需要urwid。 内嵌的urwid_win_patch.py是基于<a class=\"reference external\" href=\"https://www.gnu.org/licenses/old-licenses/lgpl-2.1.html\">GNU LESSER GENERAL PUBLIC LICENSE V2</a>。"
                        ,"__paragraph11": "在Windows平台上需要Microsoft Visual C++ 2019 Redistributable(X64)。如果安装后您还是不能import atomic_shared_memory, 请从我们的网站下载<a class=\"reference external\" href=\"https://gitee.com/irvinren/shared_atomic_enterprise/blob/master/vcomp140.dll\">微软C/C++ OpenMP运行时14.29</a>，然后将这个DLL文件复制到%windir%\\system32目录下。"
                        ,"__paragraph12": "在Windows平台上需要windows-curses>=2.3.1。"
                        ,"__paragraph13": "此模块的使用示例, 请参见<a class=\"reference internal\" href=\"atomic_api_example\"><span class=\"doc std std-doc\">无需用锁API示例</span></a>。"
                        ,"__paragraph14": "关于V2版本的文章, 标题为“Python shared atomic data types”已经在 <a class=\"reference external\" href=\"https://onlinelibrary.wiley.com/journal/1097024x\">Software: Practice and Experience</a>，doi：<a class=\"reference external\" href=\"https://onlinelibrary.wiley.com/doi/full/10.1002/spe.3259\">10.1002/spe.3259</a>上发表。V3和V4版本实现了更好的性能和功能。"
                        ,"__link_atomic_int": "原子整数"
                        ,"__link_atomic_uint": "原子无符号整数"
                        ,"__link_atomic_bool": "原子布尔"
                        ,"__link_atomic_float": "原子浮点数"
                        ,"__link_atomic_bytearray": "原子字节数组"
                        ,"__link_atomic_shared_memory": "原子共享内存"
                        ,"__link_atomic_list": "原子列表"
                        ,"__link_atomic_string": "原子字符串"
                        ,"__link_atomic_set": "原子集合"
                        ,"__link_shared_dict": "共享字典"
                        ,'__buy_enterprise_version':"购买企业版"
                        ,'__acitvation':"激活"
                        ,'__subscription':"新闻续订"
                        ,'__use_pip':"使用pip"
                        ,'__access_github':"访问Gitlab"
                        ,'__payment':"使用微信支付或Paypal"
                        ,'__through_net':"联网或通过代理服务器"
                        ,'__throw_maillist':"通过邮件列表"
                        ,'__install_through_pip':"安装pypi包"
                        ,'__post_sales_support':"售后支持"
                    },
                    'zh_HK': {
                         "__title": "Python無需用鎖的共享類型"
                        ,"__paragraph1": "此模塊可以用來完成多線程，多進程或者多協程環境下的對共享數據的併發訪問，無需用鎖即可滿足數據一致性。"
                        ,"__paragraph2": "包括數據類型："
                        ,"__paragraph3": "V4.2版已經上市! 新設計的無需主節點模式的API和<a class=\"reference internal\" href=\"shared_dict\"><span class=\"doc std std-doc\"></span>可併發訪問的共享字典</span></a>可以用於更加靈活多變的基於x64, arm64和龍芯loongarch64的主流平台的高性能應用程序。</a>"
                        ,"__paragraph4": "安裝此軟件，請參考<a class=\"reference external\" href=\"https://pypi.org/project/shared-atomic-enterprise/\">Pypi包Shared Atomic Enterprise</a>。龍芯Loongarch64平台上本產品的安裝，請到<a class=\"reference external\" href=\"https://gitee.com/irvinren/shared_atomic_enterprise/releases/\">Shared Atomic Enterprise for Loongarch64</a>下載二進制包，然後用pip install shared_atomic_enterprise-5!xx-cp3x-none-linux_loongarch64.whl進行安裝。 激活企業版，請參見<a class=\"reference internal\" href=\"atomic_tools\">激活/修改代理服務器</a>。如果對此軟件有更多需求和更多關於缺陷的提交, 請訪問我們的<a class=\"reference external\" href=\"https://sharedatomic.top:4343/\">Gitlab</a>。"
                        ,"__paragraph5": "您也可以<a class=\"reference external\" href=\"mailto:shared_atomic_enterprise_subscriber%40sharedatomic.top\">續訂或取消續訂</a>我們的郵件列表以獲取最新的產品信息。"
                        ,"__paragraph6": "企業版共享原子性安裝依賴："
                        ,"__support": "支持"
                        ,"__paragraph7": "支持的平檯："
                        ,"__paragraph8": "x86_64平檯"
                        ,"__paragraph15": "全部功能需要macOS Ventura 及以上, Microsoft Windows 10, 11, Windows Server 2019, 2022, Centos/RHEL 8, 9, 10, Suse Linux Enterprise Server 15, 16, Ubuntu Linux 18, 20, 22, 24, Debian 10, 11, 12, 13, 麒麟V10, V11, 統信20, OpenEulerOS 20, 22, 24, 百度Linux 3，騰訊OS 3, 4，阿裏巴巴雲Linux 3, 4"
                        ,"__paragraph16":  "aarch64平檯"
                        ,"__paragraph17":  "Centos/RHEL 8, Ubuntu Linux 18(glibc必鬚升級到2.28), 20, 22, 24, Debian 10, 11, 12, 13, 麒麟V10, 統信20, OpenEulerOS 20, 22, 華爲雲EulerOS 2, 阿裏巴巴雲Linux 3, 4"
                        ,"__paragraph18":  "Loongarch64平檯"
                        ,"__paragraph19":  "Loongix 20"
                        ,"__paragraph20":  "產品購買與使用流程:"
                        ,"__paragraph9": "企業版在linux平台上需要libgomp"
                        ,"__paragraph10": "企業版激活需要urwid。 內嵌的urwid_win_patch.py是基於<a class=\"reference external\" href=\"https://www.gnu.org/licenses/old-licenses/lgpl-2.1.html\">GNU LESSER GENERAL PUBLIC LICENSE V2</a>。"
                        ,"__paragraph11": "在Windows平台上需要Microsoft Visual C++ 2019 Redistributable(X64)。如果安裝後您還是不能import atomic_shared_memory, 請從我們的網站下載<a class=\"reference external\" href=\"https://gitee.com/irvinren/shared_atomic_enterprise/blob/master/vcomp140.dll\">微軟C/C++ OpenMP運行時14.29</a>，然後將這個DLL文件複製到%windir%\\system32目錄下。"
                        ,"__paragraph12": "在Windows平台上需要windows-curses>=2.3.1。"
                        ,"__paragraph13": "此模塊的使用示例, 請參見<a class=\"reference internal\" href=\"atomic_api_example\"><span class=\"doc std std-doc\">無需用鎖API示例</span></a>。"
                        ,"__paragraph14": "關於V2版本的文章, 標題為“Python shared atomic data types”已經在 <a class=\"reference external\" href=\"https://onlinelibrary.wiley.com/journal/1097024x\">Software: Practice and Experience</a>，doi：<a class=\"reference external\" href=\"https://onlinelibrary.wiley.com/doi/full/10.1002/spe.3259\">10.1002/spe.3259</a>上發表。V3和V4版本實現了更好的性能和功能。"
                        ,"__link_atomic_int": "原子整數"
                        ,"__link_atomic_uint": "原子無符號整數"
                        ,"__link_atomic_bool": "原子布爾"
                        ,"__link_atomic_float": "原子浮點數"
                        ,"__link_atomic_bytearray": "原子字節數組"
                        ,"__link_atomic_shared_memory": "原子共享內存"
                        ,"__link_atomic_list": "原子列錶"
                        ,"__link_atomic_string": "原子字符串"
                        ,"__link_atomic_set": "原子集合"
                        ,"__link_shared_dict": "共享字典"
                        ,'__buy_enterprise_version':"購買企業版"
                        ,'__acitvation':"激活"
                        ,'__subscription':"新聞續訂"
                        ,'__use_pip':"使用pip"
                        ,'__access_github':"訪問Gitlab"
                        ,'__payment':"使用微信支付或Paypal"
                        ,'__through_net':"聯網或通過代理服務器"
                        ,'__throw_maillist':"通過郵件列錶"
                        ,'__install_through_pip':"安裝pypi包"
                        ,'__post_sales_support':"售後支持"
                    },
                    'zh_TW': {
                         "__title": "Python無需用鎖的共享類型"
                        ,"__paragraph1": "此模塊可以用來完成多線程，多進程或者多協程環境下的對共享數據的併發訪問，無需用鎖即可滿足數據一致性。"
                        ,"__paragraph2": "包括數據類型："
                        ,"__paragraph3": "V4.2版已經上市! 新設計的無需主節點模式的API和<a class=\"reference internal\" href=\"shared_dict\"><span class=\"doc std std-doc\"></span>可併發訪問的共享字典</span></a>可以用於更加靈活多變的基於x64, arm64和龍芯loongarch64的主流平臺的高性能應用程序。</a>"
                        ,"__paragraph4": "安裝此軟件，請參考<a class=\"reference external\" href=\"https://pypi.org/project/shared-atomic-enterprise/\">Pypi包Shared Atomic Enterprise</a>。龍芯Loongarch64平臺上本產品的安裝，請到<a class=\"reference external\" href=\"https://gitee.com/irvinren/shared_atomic_enterprise/releases/\">Shared Atomic Enterprise for Loongarch64</a>下載二進制包，然後用pip install shared_atomic_enterprise-5!xx-cp3x-none-linux_loongarch64.whl進行安裝。 激活企業版，請參見<a class=\"reference internal\" href=\"atomic_tools\">激活/修改代理服務器</a>。如果對此軟件有更多需求和更多關於缺陷的提交, 請訪問我們的<a class=\"reference external\" href=\"https://sharedatomic.top:4343/\">Gitlab</a>。"
                        ,"__paragraph5": "您也可以<a class=\"reference external\" href=\"mailto:shared_atomic_enterprise_subscriber%40sharedatomic.top\">續訂或取消續訂</a>我們的郵件列表以獲取最新的產品信息。"
                        ,"__paragraph6": "企業版共享原子性安裝依賴："
                        ,"__support": "支持"
                        ,"__paragraph7": "支持的平枱："
                        ,"__paragraph8": "x86_64平枱"
                        ,"__paragraph15": "全部功能需要macOS Ventura 及以上, Microsoft Windows 10, 11, Windows Server 2019, 2022, Centos/RHEL 8, 9, 10, Suse Linux Enterprise Server 15, 16, Ubuntu Linux 18, 20, 22, 24, Debian 10, 11, 12, 13, 麒麟V10, V11, 統信20, OpenEulerOS 20, 22, 24, 百度Linux 3，騰訊OS 3, 4，阿裏巴巴雲Linux 3, 4"
                        ,"__paragraph16":  "aarch64平枱"
                        ,"__paragraph17":  "Centos/RHEL 8, Ubuntu Linux 18(glibc必鬚升級到2.28), 20, 22, 24, Debian 10, 11, 12, 13, 麒麟V10, 統信20, OpenEulerOS 20, 22, 華爲雲EulerOS 2, 阿裏巴巴雲Linux 3, 4"
                        ,"__paragraph18":  "Loongarch64 平枱"
                        ,"__paragraph19":  "Loongix 20"
                        ,"__paragraph20":  "產品購買與使用流程:"
                        ,"__paragraph9": "企業版在linux平臺上需要libgomp。"
                        ,"__paragraph10": "企業版激活需要urwid。 內嵌的urwid_win_patch.py是基於<a class=\"reference external\" href=\"https://www.gnu.org/licenses/old-licenses/lgpl-2.1.html\">GNU LESSER GENERAL PUBLIC LICENSE V2</a>。"
                        ,"__paragraph11": "在Windows平臺上需要Microsoft Visual C++ 2019 Redistributable(X64)。如果安裝後您還是不能import atomic_shared_memory, 請從我們的網站下載<a class=\"reference external\" href=\"https://gitee.com/irvinren/shared_atomic_enterprise/blob/master/vcomp140.dll\">微軟C/C++ OpenMP運行時14.29</a>，然後將這個DLL文件複製到%windir%\\system32目錄下。"
                        ,"__paragraph12": "在Windows平臺上需要windows-curses>=2.3.1。"
                        ,"__paragraph13": "此模塊的使用示例, 請參見<a class=\"reference internal\" href=\"atomic_api_example\"><span class=\"doc std std-doc\">無需用鎖API示例</span></a>。"
                        ,"__paragraph14": "關於V2版本的文章, 標題為“Python shared atomic data types”已經在 <a class=\"reference external\" href=\"https://onlinelibrary.wiley.com/journal/1097024x\">Software: Practice and Experience</a>，doi：<a class=\"reference external\" href=\"https://onlinelibrary.wiley.com/doi/full/10.1002/spe.3259\">10.1002/spe.3259</a>上發表。V3和V4版本實現了更好的性能和功能。"
                        ,"__link_atomic_int": "原子整數"
                        ,"__link_atomic_uint": "原子無符號整數"
                        ,"__link_atomic_bool": "原子布爾"
                        ,"__link_atomic_float": "原子浮點數"
                        ,"__link_atomic_bytearray": "原子字節數組"
                        ,"__link_atomic_shared_memory": "原子共享內存"
                        ,"__link_atomic_list": "原子列錶"
                        ,"__link_atomic_string": "原子字符串"
                        ,"__link_atomic_set": "原子集合"
                        ,"__link_shared_dict": "共享字典"
                        ,'__buy_enterprise_version':"購買企業版"
                        ,'__acitvation':"激活"
                        ,'__subscription':"新聞續訂"
                        ,'__use_pip':"使用pip"
                        ,'__access_github':"訪問Gitlab"
                        ,'__payment':"使用微信支付或Paypal"
                        ,'__through_net':"聯網或通過代理服務器"
                        ,'__throw_maillist':"通過郵件列錶"
                        ,'__install_through_pip':"安裝pypi包"
                        ,'__post_sales_support':"售後支持"
                    }
                }})
        return {
            t
            ,width
            ,locale
        }
    },
    mounted() {
      this.width=window.screen.width;
    },

    components: {
        dot
    }
}
</script>


<style scoped>

    .level1 {
        position: relative;
        list-style-type: none;
    }

    .level2 {
        position: relative;
        list-style-type: none;
    }

    .dot {
        display: inline-block;
    }

    .purchase_process_svg {
        width: 100%;
    }

    .purchase_process {
      position: relative;
    }
    .purchase_process > div {
        position: absolute;
    }

    @media screen and (max-width: 768px){
        .purchase_process_svg {
            height: 10vw;
        }

        .dot {
            width: 1vw;
        }

        .level1 {
            left: 5vw;
            width: 95vw;
        }

        .level2 {
            left: 6.8vw;
            width: 93.2vw;
        }

        p {
            margin-bottom: 1vw;
        }

        .purchase_process {
            margin: 3vw 0;
        }

        .buy_enterprise_version {
          top: 1.6vw;
          left: v-bind("locale == 'en'? '3vw': '4.9vw'");
          font-size: v-bind("locale == 'en'? '1.6vw': '2.5vw'");
          color: white;
        }

        .activation {
          top: 1.6vw;
          left: v-bind("locale == 'en'? '46.5vw': '47.5vw'");
          color: white;
          font-size: v-bind("locale == 'en'? '1.6vw': '2.5vw'");
        }

        .subscription {
          top: 1.6vw;
          left: v-bind("locale == 'en'? '82.7vw': '84.2vw'");
          color: white;
          font-size: v-bind("locale == 'en'? '1.6vw': '2.5vw'");
        }

        .use_pip {
          top: 0.5vw;
          left: v-bind("locale == 'en'? '27.9vw': '25.9vw'");
          color: grey;
          font-size: v-bind("locale == 'en'? '1.6vw': '2.2vw'");
        }
        
        .access_github {
          top: 0.5vw;
          left: v-bind("locale == 'en'? '65.1vw': '64.1vw'");
          color: grey;
          font-size: v-bind("locale == 'en'? '1.6vw': '2.2vw'");
        }

        .payment {
          top: 6vw;
          left: v-bind("locale == 'en'? '2vw': '0'");
          color: grey;
          font-size: v-bind("locale == 'en'? '1.6vw': '2.2vw'");
        }

        .through_net {
          top: 6vw;
          left: 39.5vw;
          color: grey;
          font-size: v-bind("locale == 'en'? '1.6vw': '2.2vw'");
        }

        .throw_maillist {
          top: 6vw;
          left: v-bind("locale == 'en'? '83.5vw': '82.5vw'");
          color: grey;
          font-size: v-bind("locale == 'en'? '1.6vw': '2.2vw'");
        }

        .install_through_pip {
          top: 4.2vw;
          left: v-bind("locale == 'en'? '23.7vw': '24.2vw'");
          color: white;
          font-size: v-bind("locale == 'en'? '1.6vw': '2.5vw'");
        }

        .post_sales_support {
          top: 4.2vw;
          left: v-bind("locale == 'en'? '63.7vw': '65.2vw'");
          color: white;
          font-size: v-bind("locale == 'en'? '1.6vw': '2.5vw'");
        }
    }

    @media screen and (max-width: 1080px) and (min-width: 768px){
        .dot {
            width: 0.2vw;
        }

        .purchase_process_svg {
            height: 10vw;
        }

        .level1 {
            left: 3vw;
            width: 97vw;
        }

        .level2 {
            left: 4.4vw;
            width: 95.6vw;
        }

        p {
            margin-bottom: 1vw;
        }

        .purchase_process {
            margin: 3vw 0;
        }

        .buy_enterprise_version {
          top: 1.5vw;
          left: v-bind("locale == 'en'? '2.8vw': '4.9vw'");
          font-size: v-bind("locale == 'en'? '1.6vw': '2.5vw'");
          color: white;
        }

        .activation {
          top: 2vw;
          left: v-bind("locale == 'en'? '46.5vw': '47.5vw'");
          color: white;
          font-size: v-bind("locale == 'en'? '1.6vw': '2.5vw'");
        }

        .subscription {
          top: 2vw;
          left: v-bind("locale == 'en'? '82.2vw': '84.2vw'");
          color: white;
          font-size: v-bind("locale == 'en'? '1.6vw': '2.5vw'");
        }

        .use_pip {
          top: 0.8vw;
          left: v-bind("locale == 'en'? '27vw': '27vw'");
          color: grey;
          font-size: v-bind("locale == 'en'? '1.6vw': '1.9vw'");

        }
        
        .access_github {
          top: 0.8vw;
          left: v-bind("locale == 'en'? '64.9vw': '65.1vw'");
          color: grey;
          font-size: v-bind("locale == 'en'? '1.6vw': '1.9vw'");
        }

        .payment {
          top: 7vw;
          left: v-bind("locale == 'en'? '3vw': '1vw'");
          color: grey;
          font-size: v-bind("locale == 'en'? '1.6vw': '1.9vw'");
        }

        .through_net {
          top: 7vw;
          left: v-bind("locale == 'en'? '37.8vw': '40.8vw'");
          color: grey;
          font-size: v-bind("locale == 'en'? '1.6vw': '1.9vw'");
        }

        .throw_maillist {
          top: 7vw;
          left: 83.5vw;
          color: grey;
          font-size: v-bind("locale == 'en'? '1.6vw': '1.9vw'");
        }

        .install_through_pip {
          top: 4.5vw;
          left: v-bind("locale == 'en'? '23.2vw': '24.2vw'");
          color: white;
          font-size: v-bind("locale == 'en'? '1.6vw': '2.5vw'");
        }

        .post_sales_support {
          top: 4.3vw;
          left: v-bind("locale == 'en'? '64.2vw': '65.2vw'");
          color: white;
          font-size: v-bind("locale == 'en'? '1.6vw': '2.5vw'");
        }
    }

    @media (min-width: 1080px) {

        .dot {
            width: 0.05rem;
        }

        .purchase_process_svg {
            height: 0.8rem;
        }

        .level1 {
            left: 0.25rem;
            width: 7.455rem;
        }

        .level2 {
            left: 0.33rem;
        }

        p {
            margin-bottom: 0.11rem;
        }

        .buy_enterprise_version {
          top: 0.16rem;
          left: v-bind("locale == 'en'? '0.25rem': '0.455rem'");
          font-size: v-bind("locale == 'en'? '0.12rem': '0.15rem'");
          color: white;
        }

        .activation {
          top: 0.2rem;
          left: v-bind("locale == 'en'? '3.57rem': '3.71rem'");
          font-size: v-bind("locale == 'en'? '0.12rem': '0.15rem'");
          color: white;
        }

        .subscription {
          top: 0.2rem;
          left: v-bind("locale == 'en'? '6.36rem': '6.57rem'");
          font-size: v-bind("locale == 'en'? '0.12rem': '0.15rem'");
          color: white;
        }

        .use_pip {
          top: 0.1rem;
          left: 2.15rem;
          left: v-bind("locale == 'en'? '2.15rem': '2.15rem'");
          color: grey;
          font-size: v-bind("locale == 'en'? '0.11rem': '0.15rem'");

        }
        
        .access_github {
          top: 0.1rem;
          left: 5.1rem;
          color: grey;
          font-size: 0.11rem
        }

        .payment {
          top: 0.55rem;
          left: 0.3rem;
          color: grey;
          font-size: 0.11rem
        }

        .through_net {
          top: 0.55rem;
          left: v-bind("locale == 'en'? '3.05rem': '3.3rem'");
          color: grey;
          font-size: 0.11rem
        }

        .throw_maillist {
          top: 0.55rem;
          left: v-bind("locale == 'en'? '6.45rem': '6.57rem'");
          color: grey;
          font-size: 0.11rem
        }

        .install_through_pip {
          top: 0.39rem;
          left: v-bind("locale == 'en'? '1.85rem': '2rem'");
          font-size: v-bind("locale == 'en'? '0.12rem': '0.15rem'");
          color: white;
        }

        .post_sales_support {
          top: 0.39rem;
          left: v-bind("locale == 'en'? '4.95rem': '5.1rem'");
          font-size: v-bind("locale == 'en'? '0.12rem': '0.15rem'");
          color: white;
        }

    }
</style>